<template>
    <overlay-modal class="without-header" ref="overlayModal" style="z-index: 1040">
        <template>
            <div class="modal-map">
                <div :class=classes>
                    <div>
                        <div class="mb-5">
                        <p class="mb-1 text-uppercase">
                            <b>{{hotels.length}}</b> hotel {{hotels.length===1? 'trovato' : 'trovati'}}
                        </p>
                        <div>
                            <CustomOrderSelect :list="order" class="lg" @change="onChangeOrder"/>
                        </div>
                    </div>
                        <div class="mb-3 d-flex justify-content-between">
                            <div class="d-flex">
                                <p class="mb-0"><b>Filtra risultati</b><span> | {{counter}}</span></p>
                            </div>
                            <div>
                                <button class="btn btn-sm btn-secondary" @click="onResetFilter" :disabled="isDisabledReset">reset</button>
                            </div>
                        </div>
                        <div>
                            <DropdownFilterHotel :is-dropdown="false" :list="hotels" :value="getFilter" />
                        </div>
                    </div>
                    <div>
                        <div :style="`height: ${windowHeight-55}px;`" class="tasks pb-5">
                            <div v-for="(item, index) in hotelsFiltered" :key="index" @mouseover="onMouseHover(item)">
                                <HotelPanel :minimize="expanded" :value="item" class="mb-3" :selected="isSelectedHotel(item)" @select="onSelectHotel" @detail="onShowDetail"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-secondary" @click="onChangeExpand">espandi mappa</button>
                        <GmapMap ref="mapRef" :options="{
                           zoomControl: true,
                           mapTypeControl: false,
                           scaleControl: true,
                           streetViewControl: false,
                           rotateControl: false,
                           fullscreenControl: false,
                           disableDefaultUi: false
                         }" :center="center" :zoom="zoom" map-type-id="terrain" class="map">
                            <gmap-custom-marker :offsetY="-10" :key="index" v-for="(m, index) in markers" :z-index="m.zIndex" @click.native="onSelectMarker(m)" :marker="m" alignment="top">
                                <CustomHotelMarker :value="m" :hover="selectedItem"/>
                            </gmap-custom-marker>
                        </GmapMap>
                    </div>
                </div>
            </div>
            <div>
                <ModalHotelDetail v-if="showItem" :is-selected="isSelectedHotel(showItem)" :value="showItem" ref="modalHotelDetail" @select="onSelectHotel"/>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vueWindowSizeMixin } from 'vue-window-size'
import OverlayModal from '../../../../modals/OverlayModal'
import TimeRangeSlider from '../../../common/TimeRangeSlider'
import ServicePanel from '../../../common/ServicePanel'
import CustomOrderSelect from '../../../common/CustomOrderSelect'
import HotelPanel from '../HotelPanel'
import ShowMore from '../../../common/ShowMore'
import {LATITUDE, LONGITUDE} from '../../../../../utils/config'
import {hotelName} from '../../../../../utils/helper'
import DropdownFilterHotel from '../dropdown/DropdownFilterHotel'
import {defaultFiltererHotel, defaultSorterHotel} from '../../../../../utils/hotelUtils'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import CustomHotelMarker from '../../../common/google-map/CustomHotelMarker'
import ModalHotelDetail from './ModalHotelDetail'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import HotelActions from '../../../../actions/HotelAction'

const DEFAULT_BOUND_ZOOM = 13
const DEFAULT_ZOOM = 11

export default {
  mixins: [vueWindowSizeMixin, AnalyticEvents, HotelActions],
  name: 'ModalHotelsMap',
  components: { ModalHotelDetail, CustomHotelMarker, GmapCustomMarker, DropdownFilterHotel, ShowMore, HotelPanel, CustomOrderSelect, ServicePanel, TimeRangeSlider, OverlayModal },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      showItem: this.list[0],
      selectedItem: this.list[0],
      expanded: false,
      openOrder: false,
      showAll: false,
      center: {lat: LATITUDE, lng: LONGITUDE},
      zoom: DEFAULT_BOUND_ZOOM,
      order: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ]
    }
  },
  computed: {
    classes: function () {
      return this.expanded ? 'expanded d-flex justify-content-around' : 'd-flex justify-content-around'
    },
    counter () {
      return this.hotelsFiltered.length
    },
    getFilter: function () {
      return this.getHotelsFilter()
    },
    isDisabledReset () {
      return Object.values(this.getFilter).every(x => x == null)
    },
    hotels () {
      return this.list
    },
    hotelsFiltered () {
      return this.hotels.filter(this.filtererHotel).sort(this.sortererHotel)
    },
    markers () {
      const list = this.hotelsFiltered
      return list.map((item) => {
        const selected = this.isSelectedHotel(item)
        const delta = this.deltaPrice(item)
        const sign = this.sign(item)
        const abs = this.abs(item)
        const zIndex = selected ? 52 : 50
        const {latitude, longitude, name} = item.hotel.location
        return {name: hotelName(name), lat: latitude, lng: longitude, selected, delta, sign, abs, item, zIndex, hover: false}
      })
    }
  },
  methods: {
    ...mapGetters(['getTypesRating', 'getHotelsFilter', 'getHotelsOrder']),
    ...mapActions(['modifyHotelFilter', 'modifyHotelOrder', 'resetHotelFilter']),
    hotelName,
    open () {
      this.zoom = DEFAULT_BOUND_ZOOM
      const coords = this.markers.map(item => {
        return {lat: item.lat, lng: item.lng}
      })
      this.$refs.mapRef.$mapPromise.then((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        coords.forEach(c => {
          bounds.extend(c)
        })
        map.panToBounds(bounds)
      })
      this.$refs.overlayModal.open()
    },
    close () {
      this.$refs.overlayModal.close()
    },
    onChangeExpand () {
      this.expanded = !this.expanded
    },
    onResetFilter: function () {
      this.resetHotelFilter()
    },
    onOpenOrder () {
      this.openOrder = !this.openOrder
    },
    onSelectMarker (marker) {
      this.onShowDetail(marker.item)
    },
    onSelectHotel () {
      this.trackModaleListaHotelSeleziona()
      this.close()
    },
    onShowDetail (hotel) {
      this.showItem = null
      this.$nextTick(() => {
        this.showItem = hotel
        this.$nextTick(() => {
          this.trackModaleListaHotelInfo()
          this.$refs.modalHotelDetail.open()
        })
      })
    },
    isSelectedHotel (hotel) {
      if (!hotel) return false
      const list = this.$store.getters.getSelectedHotelsByPeriod(hotel.period)
      return list.some(item => {
        return hotel.hotel.location.name === item.hotel.location.name
      })
    },
    onMouseHover (item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item
        this.markers.forEach(marker => {
          if (marker.item.hotel.location.name === item.hotel.location.name) {
            marker.hover = true
            marker.zIndex = 3
          } else {
            marker.zIndex = -1
          }
        })
        const latitude = item.hotel.location.latitude
        const longitude = item.hotel.location.longitude
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.zoom = DEFAULT_ZOOM
          map.panTo({lat: latitude, lng: longitude})
        })
      }
    },
    filtererHotel (item) {
      return defaultFiltererHotel(item, this.getHotelsFilter(), this.getTypesRating())
    },
    sortererHotel (a, b) {
      return defaultSorterHotel(a, b, this.getHotelsOrder())
    },
    onChangeOrder: function (order) {
      this.modifyHotelOrder({prezzo: order.dir})
    },
    deltaPrice (item) {
      const selected = this.$store.getters.getSelectedHotelsByPeriod(item.period)[0]
      return item.venditaTotaleEuroBase - selected.venditaTotaleEuroBase
    },
    sign (item) {
      const price = this.deltaPrice(item)
      if (price === 0) return ''
      return price >= 0 ? '+' : '-'
    },
    abs (item) {
      return Math.abs(this.deltaPrice(item))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/modals/ModalHotelsMap.vue